export type IParseTime = (
  timeFormat: string,
  timeString: string
) => {
  ampm: string;
  hour: number;
  minute: number;
  second: number;
  timezone: string;
};

export function parseTime(
  timeFormat: string,
  timeString: string
): {
  ampm: string;
  hour: number;
  minute: number;
  second: number;
  timezone: string;
} {
  const regstr =
    timeFormat
      .toString()
      .replace(/h{1,2}/gi, '(\\d?\\d)')
      .replace(/min/gi, '(\\d?\\d)')
      .replace(/s{1,2}/gi, '(\\d?\\d)')
      .replace(/t{1,2}/gi, '(am|pm|a|p)?')
      .replace(/z{1}/gi, '((\\+|-)\\d\\d\\d\\d)?')
      .replace(/\s/g, '\\s?') + '$';
  const order = window.DexeroCoreApp.getTimeFormatPositions(timeFormat);
  const time = {
    ampm: '',
    hour: 0,
    minute: 0,
    second: 0,
    timezone: '+0000',
  };
  const treg = timeString.match(new RegExp(regstr));

  if (treg) {
    if (order.t !== -1) {
      time.ampm = (treg[order.t] === undefined || treg[order.t].length === 0
        ? ''
        : treg[order.t].charAt(0).toUpperCase() === 'A'
        ? 'AM'
        : 'PM'
      ).toUpperCase();
    }

    if (order.h !== -1) {
      if (time.ampm === 'AM' && String(treg[order.h]) === '12') {
        time.hour = 0; //  12am = 0 hour
      } else if (time.ampm === 'PM' && String(treg[order.h]) !== '12') {
        time.hour = Number((parseFloat(treg[order.h]) + 12).toFixed(0)); //  12pm = 12 hour, any other pm = hour + 12
      } else {
        time.hour = Number(treg[order.h]);
      }
    }

    if (order.m !== -1) {
      time.minute = Number(treg[order.m]);
    }
    if (order.s !== -1) {
      time.second = Number(treg[order.s]);
    }
    if (order.z !== -1) {
      time.timezone = treg[order.z];
    }
  }
  return time;
}
